import { DropdownMenuSeparator } from "@cmp-src/primitives/dropdown-menu";
import { cn } from "@gettactic/helpers";
import React from "react";

interface MenuSeparatorProps {
  className?: string;
}

export const LoggedUserNavMenuSeparator: React.FC<MenuSeparatorProps> = ({
  className
}) => <DropdownMenuSeparator className={cn("m-0", className)} />;
